import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import db from '../services/db';
import { buildSiteVisitPayload } from '../utils/siteVisitTracker';

/**
 * First-party page-view logging (anonymous + signed-in). Independent of VK pixel.
 */
export default function SiteVisitTracker() {
    const location = useLocation();
    const prevPathRef = useRef(null);

    useEffect(() => {
        const path = `${location.pathname}${location.search}`;
        if (prevPathRef.current === path) return;
        prevPathRef.current = path;

        const payload = buildSiteVisitPayload(location.pathname, location.search);
        if (!payload) return;

        db.logSiteVisit(payload).catch(() => {});
    }, [location.pathname, location.search]);

    return null;
}
